import type { RumEvent } from '@datadog/browser-rum';

// The claim token is a bearer secret and the RFA handle identifies the member,
// so neither may reach RUM.
const redactUrl = (url: string): string =>
  url
    .replace(/\/pay\/rfa\/[^/?#]+/, '/pay/rfa/[REDACTED rfa handle]')
    .replace(
      /((\/pay\/)|(\/request\/))[0-9a-zA-Z-]{23}/,
      '$1[REDACTED pay friends token]'
    );

// RUM beforeSend: mutates the event in place.
export const redactRumEvent = (event: RumEvent): void => {
  const view = event.view as { url: string; referrer?: string };
  view.url = redactUrl(view.url);
  if (view.referrer) view.referrer = redactUrl(view.referrer);
  if (event.type === 'resource') {
    const resource = event.resource as { url: string };
    resource.url = redactUrl(resource.url);
  }
};
